import { useMutation, useQuery, useQueryClient } from 'react-query';

import {
  approveAgreementPricing,
  getAgreementPricing,
  rejectAgreementPricing,
  submitAgreementPricing,
} from '~/api/agreementPricing';
import { ApiError } from '~/types/ApiError';
import { AgreementPricingPayload, AgreementPricingResponse } from '~/types/ksa/AgreementPricing';
import { agentActivityLogKey } from '~/controllers/agentReview';

export const AGREEMENT_PRICING_QUERY_KEY = 'agreementPricing';

export const useGetAgreementPricing = (enabled = true) =>
  useQuery<AgreementPricingResponse, ApiError>(AGREEMENT_PRICING_QUERY_KEY, getAgreementPricing, {
    enabled,
  });

export const useSubmitAgreementPricing = () => {
  const queryClient = useQueryClient();
  return useMutation<AgreementPricingResponse, ApiError, AgreementPricingPayload>(
    submitAgreementPricing,
    {
      onSuccess: (data) => {
        queryClient.setQueryData(AGREEMENT_PRICING_QUERY_KEY, data);
        void queryClient.invalidateQueries(agentActivityLogKey);
      },
    },
  );
};

export const useApproveAgreementPricing = () => {
  const queryClient = useQueryClient();
  return useMutation<
    AgreementPricingResponse,
    ApiError,
    { products: AgreementPricingPayload['products'] }
  >(({ products }) => approveAgreementPricing({ products }), {
    onSuccess: (data) => {
      queryClient.setQueryData(AGREEMENT_PRICING_QUERY_KEY, data);
      void queryClient.invalidateQueries(agentActivityLogKey);
    },
  });
};

export const useRejectAgreementPricing = () => {
  const queryClient = useQueryClient();
  return useMutation<AgreementPricingResponse, ApiError, { rejectionReason: string }>(
    ({ rejectionReason }) => rejectAgreementPricing(rejectionReason),
    {
      onSuccess: (data) => {
        queryClient.setQueryData(AGREEMENT_PRICING_QUERY_KEY, data);
      },
    },
  );
};
